angular.module('tf.services')

    .service('ConfirmExitService', ['$window','NotificationService','$state', function ($window, NotificationService, $state) {

        this.onBeforeUnload = function(message) {
            return function (e) {
                e = e || window.event;
                if (e){ e.returnValue = message;}
                return message;
            };
        };
        var removeConfirmation = function(){
            $window.onbeforeunload = null;
        };

        var exitConfirmationPopup = function(toState, toParams, title, content){
            NotificationService.popup('confirm-exit', {
                state: toState,
                params: toParams,
                $state: $state,
                title : title,
                content : content,
                onLeave: toParams.onLeave || removeConfirmation
            });
        };
        this.popup = exitConfirmationPopup;


        this.confirmExit = function(scope, message){
            var confirmOnPageExit = function (e) {
                e = e || window.event;
                if (e){ e.returnValue = message;}
                return message;
            };

            $window.onbeforeunload = confirmOnPageExit;

            scope.$on("$destroy", function() {
                $window.onbeforeunload = null;
            });
            scope.$on('$stateChangeStart', function(event, toState, toParams) {
                if($window.onbeforeunload) {
                    exitConfirmationPopup(toState, toParams);
                    event.preventDefault();
                }
            });
        };
        return this;
    }])
;
